import React, { Fragment } from "react";
import Lottie from "react-lottie";
import * as pinFalse from "./pinFalse.json";

function PinFalse() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: pinFalse.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Fragment>
      <Lottie options={defaultOptions} width={200} height={200} />
    </Fragment>
  );
}

export default PinFalse;
